import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { format } from "date-fns";

export const useTrends = ({
	participantId,
	startDate,
	biometricType,
}: {
	participantId: number;
	startDate: string;
	biometricType: string;
}) => {
	const queryClient = useQueryClient();
	const queryKey = ["trends-histograms", { participantId, startDate, biometricType }];
	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getBiometricTrends({
				biometricType,
				config: {
					params: {
						participantId,
						startDate,
						endDate: format(new Date(), "yyyy-MM-dd"),
					},
				},
			});
			return response;
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
